export default __webpack_public_path__ + "static/urbansitter-1-289c7455a48c1233ffb08b7cd2405a71.mp4";